import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  Resolve,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { catchError, filter, first, map } from 'rxjs/operators';

import { State, selectTenant } from '®app/ngrx/state';

import { handleRenavigationError } from '../router';

import { Tenant } from './tenant';
import { LoadTenantAction } from './tenant.actions';

@Injectable()
export class TenantGuard
  implements CanActivate, CanActivateChild, Resolve<Tenant>
{
  constructor(private router: Router, private store: Store<State>) {}

  private loadTenant(route: ActivatedRouteSnapshot): Observable<Tenant> {
    const tenantCode: string = route.paramMap.get('tenantCode');
    this.store.dispatch(new LoadTenantAction({ tenantCode }));
    return this.store
      .select(selectTenant)
      .pipe(filter(isTenantInstance), first());
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> {
    return this.loadTenant(route).pipe(
      map(isTenantInstance),
      catchError(handleRenavigationError(this.router)),
    );
  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> {
    return this.canActivate(childRoute, state);
  }

  resolve(
    route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot,
  ): Observable<Tenant> {
    return this.loadTenant(route);
  }
}

const isTenantInstance = (tenant: Tenant | null) => tenant instanceof Tenant;
